<template>
    <section class="element" :class="[$route.name]">
	<v-container fluid>
        <v-col cols="12" class="faqs">
            <v-expansion-panels>
                <v-expansion-panel
                v-for="(item,i) in 5"
                :key="i"
                >
                <v-expansion-panel-header>
                    Item
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-col>
    </v-container>
    </section>
</template>
<script>
export default {
    name: 'faq',
    data() {
        return {
        };
    },
    watch: {
    },
    mounted() {
    },
    methods: { 
    }
};
</script>
